import { getTextItemError } from "./TextInputValidator";

export const getInputTextListErrors = (control, items: string[]) => {
  const errors = items.map(item => (item ? getTextItemError(control, item) : undefined));

  if (control.isRequired && !items.some(item => item)) {
    errors[0] = "Molimo, unesite ovo polje!";
  }

  return errors;
};

export default {
  validate(control, rule, value, callback) {
    const items = value && Array.isArray(value[control.field]) ? value[control.field] : [];

    callback(getInputTextListErrors(control, items).find(error => error));
  }
};



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/InputTextListValidator.ts